<template>
  <div class="workbench_box">
    <div
      class="left"
      :style="screenWidth < 1200 ? 'display:none' : 'display:block'"
    >
      <Sidebar :menuList="menuList"></Sidebar>
    </div>
    <el-row>
      <el-col :xs="0" :lg="3">
        <span style="color: rgba(0, 0, 0, 0)">kong</span></el-col
      >
      <el-col :xs="24" :lg="21">
        <router-view></router-view>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Sidebar from "@/components/SideBar/SideBar.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      menuList: [],
    };
  },
  methods: {
    getAreaList() {
      // 区县列表
      this.$axios
        .get("/business//park/seat")
        .then((res) => {
          this.$store.commit("setAreaLsit", res.data);
        })
        .catch((res) => {
          console.log("区县列表获取失败", res);
        });
    },
    check() {
      this.dealSubMenu(this.menuListOrg, "主题数据库");
    },
    dealSubMenu(menu, sub) {
      if (menu) {
        for (let i = 0; i < menu.length; i++) {
          if (menu[i].title == sub) {
            this.menuList = menu[i].children;
          } else {
            this.dealSubMenu(menu[i].children, sub);
          }
        }
      }
    },
  },
  components: {
    Sidebar,
  },
  created() {
    this.getAreaList();
    this.check();
  },
  computed: {
    ...mapGetters({
      menuListOrg: "getSubMenuTree",
    }),
  },
  watch: {
    menuListOrg: "check",
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>
<style lang="less" scoped>
.workbench_box {
  overflow-y: auto;
  margin-top: 75px;
  .left {
    width: 13%;
    height: 100%;
    overflow-y: auto;
    position: fixed;
    left: 0;
    z-index: 999;
    box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.2);
  }
  .left::-webkit-scrollbar {
    display: none;
  }
}
@media (max-width: 1200px) {
  .workbench_box {
    margin-top: 50px;
  }
}
</style>